import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.is-nan.js";
/**
 * Try to convert a string to a number and returns a number if possible,
 * otherwise it'll return the input string.
 */

export function toNumber(input) {
  if (input === '') {
    return input;
  }
  var converted = Number(input);
  return Number.isNaN(converted) ? input : converted;
}
export default toNumber;